import Text from 'components/Text/Text';
import React, { useEffect, useState } from 'react';
import { Checkbox, Radio } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { TabOptions } from '../../../../../../../cronGeneratorState/cronGeneratorContext';
import style from './SpecificSelectors.module.scss';

interface ISpecificSelectors {
	onSetResult: (value: string) => void;
}

interface ISpecificValuesItem {
	name: string;
	value: string;
	isChecked: boolean;
}

const SpecificSelectors: React.FC<ISpecificSelectors> = ({ onSetResult }) => {
	const [checkedSpecificValues, setCheckedSpecificValues] = useState<ISpecificValuesItem[]>([]);
	const specificValues = [
		{ name: 'JAN', value: '1', isChecked: false },
		{ name: 'FEB', value: '2', isChecked: false },
		{ name: 'MAR', value: '3', isChecked: false },
		{ name: 'APR', value: '4', isChecked: false },
		{ name: 'MAY', value: '5', isChecked: false },
		{ name: 'JUN', value: '6', isChecked: false },
		{ name: 'JUL', value: '7', isChecked: false },
		{ name: 'AUG', value: '8', isChecked: false },
		{ name: 'SEP', value: '9', isChecked: false },
		{ name: 'OCT', value: '10', isChecked: false },
		{ name: 'NOV', value: '11', isChecked: false },
		{ name: 'DEC', value: '12', isChecked: false },
	];

	const result = checkedSpecificValues
		.sort((a, b) => parseInt(a.value) - parseInt(b.value))
		.map((el) => el.name)
		.join(',');

	useEffect(() => {
		onSetResult(result);
	}, [result]);

	useEffect(() => {
		const defaultValue = { ...specificValues[0], isChecked: true };
		!checkedSpecificValues.length && setCheckedSpecificValues([defaultValue]);
	}, []);

	const handleCheck = (e: CheckboxChangeEvent) => {
		setCheckedSpecificValues((prevState) => {
			const isChecked = e.target.checked;
			const value = e.target.value;
			const name = e.target.name as string;
			return isChecked
				? [...prevState, { name, value, isChecked }]
				: prevState.filter((el) => el.value !== value);
		});
	};

	return (
		<div className={style.radioField}>
			<div className={style.labelContainer}>
				<Radio value={TabOptions.SPECIFIC_OPTION} id={TabOptions.SPECIFIC_OPTION + 'monthTab'} />
				<label className={style.label} htmlFor={TabOptions.SPECIFIC_OPTION + 'monthTab'}>
					<Text translationNameSpace="form" translationKey="specificMonthLabel" asFragment={true} />
				</label>
			</div>
			<div className={style.selectors}>
				{specificValues.map((value) => {
					const checked = checkedSpecificValues.find((el) => el.value === value.value)?.isChecked;
					return (
						<Checkbox
							key={value.value}
							className={style.checkBoxElement}
							name={value.name}
							value={value.value}
							checked={checked}
							onChange={handleCheck}>
							{value.name}
						</Checkbox>
					);
				})}
			</div>
		</div>
	);
};

export default React.memo(SpecificSelectors);
